export async function watchAsset(client,params){return await client.request({method:"wallet_watchAsset",params:params},{retryCount:0})}